import script from "./RedoIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./RedoIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__